import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Traducción de un producto
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class ProductTranslation {
    public name = ''
    public description = ''
    public publicName = ''
    public shortDescription = ''

    public constructor (public locale = '') {}

    /**
     * Deserializa los datos json en una entidad traducción
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const translation = new this(data.locale)
        translation.name = data.name || ''
        translation.description = data.description || ''
        translation.publicName = data.public_name || ''
        translation.shortDescription = data.short_description || ''

        return translation
    }

    public serialize (): KeyValuePair {
        return {
            locale: this.locale,
            name: this.name,
            description: this.description,
            public_name: this.publicName,
            short_description: this.shortDescription,
        }
    }
}
